import React from 'react';
import { Tag, Typography } from 'antd';

const { Text } = Typography;

const ACTIVITY_COLORS: Record<string, string> = {
  WORKING: '#389e0d',
  IDLE: '#d48806',
  STANDBY: '#597ef7',
  BREAKDOWN: '#cf1322',
  OTHER: '#8c8c8c',
};

type TimelineEntry = {
  id: string;
  start_time: string;
  end_time: string;
  activity_type: string;
  duration_minutes?: number;
};

export const PmvActivityTimeline: React.FC<{ entries: TimelineEntry[] }> = ({ entries }) => {
  if (!entries.length) {
    return <Text type="secondary">No activities recorded yet.</Text>;
  }

  const total = entries.reduce((sum, e) => sum + (e.duration_minutes ?? 1), 0) || 1;

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          height: 28,
          borderRadius: 6,
          overflow: 'hidden',
          border: '1px solid #f0f0f0',
          marginBottom: 12,
        }}
      >
        {entries.map((entry) => (
          <div
            key={entry.id}
            title={`${entry.activity_type} ${entry.start_time}–${entry.end_time}`}
            style={{
              flex: entry.duration_minutes ?? 1,
              minWidth: 4,
              background: ACTIVITY_COLORS[entry.activity_type] ?? ACTIVITY_COLORS.OTHER,
            }}
          />
        ))}
      </div>
      {entries.map((entry) => (
        <div
          key={`row-${entry.id}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 6,
            flexWrap: 'wrap',
          }}
        >
          <Text code style={{ minWidth: 110 }}>
            {entry.start_time?.slice(0, 5)} – {entry.end_time?.slice(0, 5)}
          </Text>
          <Tag color={ACTIVITY_COLORS[entry.activity_type]} style={{ margin: 0 }}>
            {entry.activity_type}
          </Tag>
          <Text type="secondary">{entry.duration_minutes ?? 0} min</Text>
          <div
            style={{
              flex: 1,
              minWidth: 60,
              height: 6,
              borderRadius: 3,
              background: '#f5f5f5',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                width: `${Math.round(((entry.duration_minutes ?? 0) / total) * 100)}%`,
                height: '100%',
                background: ACTIVITY_COLORS[entry.activity_type] ?? ACTIVITY_COLORS.OTHER,
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
